import useSWR, { ConfigInterface } from "swr";
import { useAuthentication } from "../../auth/store/authSelectors";
import IObservation from "../../interfaces/IObservation";
import { IObservationEvent } from "../../interfaces/IObservationEvent";
import { getObservationService } from "../../services/observationService";
import * as Endpoint from "../../../endpoints";
import { TResult, getSgApiService } from "../../../../sg-core";

type TData = IObservationEvent[] | null;

export type IUseObservationItemHook = (permitId: IObservation["id"] | null, config?: ConfigInterface<TData>) => {
    data: TData;
    fetching: boolean;
}

export const useObservationHistory: IUseObservationItemHook = (permitId, config?: ConfigInterface<TData>) => {
    const { token, anonymousSession } = useAuthentication();

    const apiService = getSgApiService("");
    apiService.setToken(token || "");
    const observationService = getObservationService(apiService, Endpoint.havainnot, anonymousSession);

    const fetcher = async (): Promise<TData> => {
        if (!permitId) { return null }
        const events: TResult<IObservationEvent[]> = await observationService.getHistoryEvents(permitId);

        if (events.isFailure) {
            throw events.error
        };

        return events.value
    };

    const cacheKey = "observation:events:" + permitId;

    const { data, isValidating } = useSWR(
        cacheKey,
        fetcher,
        {
            suspense: true,
            revalidateOnFocus: true,
            revalidateOnMount: true,
            revalidateOnReconnect: false,
            refreshInterval: 1000 * 60,
            ...config
        }
    );

    const rawData = data ?? null;

    return {
        data: rawData,
        fetching: isValidating,
    }
};
